import { render, staticRenderFns } from "./ProfileWrapper.vue?vue&type=template&id=8fe827bc&scoped=true&"
import script from "./ProfileWrapper.vue?vue&type=script&lang=ts&"
export * from "./ProfileWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileWrapper.vue?vue&type=style&index=0&id=8fe827bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe827bc",
  null
  
)

export default component.exports